import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/common.json";
import pt from "./locales/pt/common.json";
import enJlptTestSites from "./locales/en/jlptTestSites.json";
import ptJlptTestSites from "./locales/pt/jlptTestSites.json";
import enHomePage from "./locales/en/homePage.json";
import ptHomePage from "./locales/pt/homePage.json";
import enAboutPage from "./locales/en/aboutPage.json";
import ptAboutPage from "./locales/pt/aboutPage.json";
import enStudyMaterialsPage from "./locales/en/studyMaterialsPage.json";
import ptStudyMaterialsPage from "./locales/pt/studyMaterialsPage.json";
import enBlogPage from "./locales/en/blogPage.json";
import ptBlogPage from "./locales/pt/blogPage.json";
import enPrivacyPolicyPage from "./locales/en/privacyPolicyPage.json";
import ptPrivacyPolicyPage from "./locales/pt/privacyPolicyPage.json";
import enNewsletterPage from "./locales/en/newsletterPage.json";
import ptNewsletterPage from "./locales/pt/newsletterPage.json";
import enNewsletterForm from "./locales/en/newsletterForm.json";
import ptNewsletterForm from "./locales/pt/newsletterForm.json";
import enLoginPage from "./locales/en/loginPage.json";
import ptLoginPage from "./locales/pt/loginPage.json";
import enRegisterPage from "./locales/en/registerPage.json";
import ptRegisterPage from "./locales/pt/registerPage.json";
import enForgotPasswordPage from "./locales/en/forgotPasswordPage.json";
import ptForgotPasswordPage from "./locales/pt/forgotPasswordPage.json";
import enConverterPage from "./locales/en/converterPage.json";
import ptConverterPage from "./locales/pt/converterPage.json";
import enRomajiConverterPage from "./locales/en/romajiConverterPage.json";
import ptRomajiConverterPage from "./locales/pt/romajiConverterPage.json";
import enWanikaniPage from "./locales/en/wanikaniPage.json";
import ptWanikaniPage from "./locales/pt/wanikaniPage.json";
import enGrammarPage from "./locales/en/grammarPage.json";
import ptGrammarPage from "./locales/pt/grammarPage.json";
import enGrammarDetailPage from "./locales/en/grammarDetailPage.json";
import ptGrammarDetailPage from "./locales/pt/grammarDetailPage.json";
import enKanaWritingPracticePage from "./locales/en/kanaWritingPracticePage.json";
import ptKanaWritingPracticePage from "./locales/pt/kanaWritingPracticePage.json";
import enKanjiWritingPracticePage from "./locales/en/kanjiWritingPracticePage.json";
import ptKanjiWritingPracticePage from "./locales/pt/kanjiWritingPracticePage.json";
import enTranslatePage from "./locales/en/translatePage.json";
import ptTranslatePage from "./locales/pt/translatePage.json";
import enConjugationPage from "./locales/en/conjugationPage.json";
import ptConjugationPage from "./locales/pt/conjugationPage.json";
import enKanjiDetailPage from "./locales/en/kanjiDetailPage.json";
import ptKanjiDetailPage from "./locales/pt/kanjiDetailPage.json";
import enVocabularyPage from "./locales/en/vocabularyPage.json";
import ptVocabularyPage from "./locales/pt/vocabularyPage.json";
import enSpeakingPracticePage from "./locales/en/speakingPracticePage.json";
import ptSpeakingPracticePage from "./locales/pt/speakingPracticePage.json";
import enKanjiMemoryQuizPage from "./locales/en/kanjiMemoryQuizPage.json";
import ptKanjiMemoryQuizPage from "./locales/pt/kanjiMemoryQuizPage.json";
import enKeyboardPage from "./locales/en/keyboardPage.json";
import ptKeyboardPage from "./locales/pt/keyboardPage.json";
import enReleasesInfoPage from "./locales/en/releasesInfoPage.json";
import ptReleasesInfoPage from "./locales/pt/releasesInfoPage.json";
import enLessonsPage from "./locales/en/lessonsPage.json";
import ptLessonsPage from "./locales/pt/lessonsPage.json";
import enProfilePage from "./locales/en/profilePage.json";
import ptProfilePage from "./locales/pt/profilePage.json";
import ptLessonContent from "./locales/pt/lessonContent.json";
import ptLessonSections from "./locales/pt/lessonSections.json";
import enKanjiGuessQuizPage from "./locales/en/kanjiGuessQuizPage.json";
import enWorksheetGeneratorPage from "./locales/en/worksheetGeneratorPage.json";
import ptWorksheetGeneratorPage from "./locales/pt/worksheetGeneratorPage.json";
import ptKanjiGuessQuizPage from "./locales/pt/kanjiGuessQuizPage.json";

// No i18next-browser-languagedetector and no i18next-http-backend yet -
// deliberately manual for this first pilot page (JlptTestSitesPage): the
// language comes from an explicit /pt prefix in the router, not
// auto-detected, and translations are bundled statically rather than
// fetched, since the two locales are still small. Revisit both choices
// once more pages are covered.
i18n.use(initReactI18next).init({
    resources: {
        en: {
            common: en,
            jlptTestSites: enJlptTestSites,
            homePage: enHomePage,
            aboutPage: enAboutPage,
            studyMaterialsPage: enStudyMaterialsPage,
            blogPage: enBlogPage,
            privacyPolicyPage: enPrivacyPolicyPage,
            newsletterPage: enNewsletterPage,
            newsletterForm: enNewsletterForm,
            loginPage: enLoginPage,
            registerPage: enRegisterPage,
            forgotPasswordPage: enForgotPasswordPage,
            converterPage: enConverterPage,
            romajiConverterPage: enRomajiConverterPage,
            wanikaniPage: enWanikaniPage,
            grammarPage: enGrammarPage,
            grammarDetailPage: enGrammarDetailPage,
            kanaWritingPracticePage: enKanaWritingPracticePage,
            kanjiWritingPracticePage: enKanjiWritingPracticePage,
            translatePage: enTranslatePage,
            conjugationPage: enConjugationPage,
            kanjiDetailPage: enKanjiDetailPage,
            vocabularyPage: enVocabularyPage,
            speakingPracticePage: enSpeakingPracticePage,
            kanjiMemoryQuizPage: enKanjiMemoryQuizPage,
            keyboardPage: enKeyboardPage,
            releasesInfoPage: enReleasesInfoPage,
            lessonsPage: enLessonsPage,
            profilePage: enProfilePage,
            kanjiGuessQuizPage: enKanjiGuessQuizPage,
            worksheetGeneratorPage: enWorksheetGeneratorPage,
        },
        pt: {
            common: pt,
            jlptTestSites: ptJlptTestSites,
            homePage: ptHomePage,
            aboutPage: ptAboutPage,
            studyMaterialsPage: ptStudyMaterialsPage,
            blogPage: ptBlogPage,
            privacyPolicyPage: ptPrivacyPolicyPage,
            newsletterPage: ptNewsletterPage,
            newsletterForm: ptNewsletterForm,
            loginPage: ptLoginPage,
            registerPage: ptRegisterPage,
            forgotPasswordPage: ptForgotPasswordPage,
            converterPage: ptConverterPage,
            romajiConverterPage: ptRomajiConverterPage,
            wanikaniPage: ptWanikaniPage,
            grammarPage: ptGrammarPage,
            grammarDetailPage: ptGrammarDetailPage,
            kanaWritingPracticePage: ptKanaWritingPracticePage,
            kanjiWritingPracticePage: ptKanjiWritingPracticePage,
            translatePage: ptTranslatePage,
            conjugationPage: ptConjugationPage,
            kanjiDetailPage: ptKanjiDetailPage,
            vocabularyPage: ptVocabularyPage,
            speakingPracticePage: ptSpeakingPracticePage,
            kanjiMemoryQuizPage: ptKanjiMemoryQuizPage,
            keyboardPage: ptKeyboardPage,
            releasesInfoPage: ptReleasesInfoPage,
            lessonsPage: ptLessonsPage,
            profilePage: ptProfilePage,
            lessonContent: ptLessonContent,
            lessonSections: ptLessonSections,
            kanjiGuessQuizPage: ptKanjiGuessQuizPage,
            worksheetGeneratorPage: ptWorksheetGeneratorPage,
        },
    },
    ns: [
        "common",
        "jlptTestSites",
        "homePage",
        "aboutPage",
        "studyMaterialsPage",
        "blogPage",
        "privacyPolicyPage",
        "newsletterPage",
        "newsletterForm",
        "loginPage",
        "registerPage",
        "forgotPasswordPage",
        "converterPage",
        "romajiConverterPage",
        "wanikaniPage",
        "grammarPage",
        "grammarDetailPage",
        "kanaWritingPracticePage",
        "kanjiWritingPracticePage",
        "translatePage",
        "conjugationPage",
        "kanjiDetailPage",
        "vocabularyPage",
        "speakingPracticePage",
        "kanjiMemoryQuizPage",
        "keyboardPage",
        "releasesInfoPage",
        "lessonsPage",
        "profilePage",
        "lessonContent",
        "lessonSections",
        "kanjiGuessQuizPage",
        "worksheetGeneratorPage",
    ],
    lng: "en",
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
